function getPropByPath(obj, path) {
  let tempObj = obj
  path = path.replace(/\[(\w+)\]/g, '.$1')
  path = path.replace(/^\./, '')
  let keyArr = path.split('.')
  let i = 0
  for (let len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj) continue
    let key = keyArr[i]
    if (key in tempObj) {
      tempObj = tempObj[key]
    } /* else {
            throw new Error('[iView warn]: please transfer a valid prop path to form item!');
        } */
  }
  return tempObj
    ? {
        o: tempObj,
        k: keyArr[i],
        v: tempObj[keyArr[i]],
      }
    : {
        o: tempObj,
        k: keyArr[i],
        v: null,
      }
}

export default getPropByPath
